import React from 'react'
import { compose } from 'recompose'
import { routesByValue } from 'helpers/routesConstant'
import withViewAllPage from 'hocs/extends/withViewAllPage'
import withDuplicateResource from 'hocs/extends/withDuplicateResource'
import AwesomeTable from 'components/Table/AwesomeTable'
import ContentCopy from 'material-ui/svg-icons/content/content-copy'
import MoreAction from 'components/MoreAction'

const ViewAllMenus = compose(
  withViewAllPage({
    resourceName: {
      singular: 'menu',
      plural: 'menus',
    },
  }),
  withDuplicateResource({
    resourceName: {
      singular: 'menu',
      plural: 'menus',
    },
  }),
)(
  ({
    menus,
    router,
    onOpenTempState,
    deleteMenu,
    deleteMenuStatus,
    setOpenModal,
    setOriginalResourceInfo,
    setNewResourceName,
    duplicateStatus,
    renderAddResourceButton,
  }) => {
    const config = [
      {
        headerLabel: 'Name',
        accessor: 'name',
        sortable: true,
        width: '65%',
      },
      {
        headerLabel: 'Last Updated',
        accessor: 'lastUpdated',
        isDate: true,
        sortable: true,
        width: '20%',
      },
      {
        width: '15%',
        renderCell: ({ rowData }) => (
          <MoreAction.Default
            grey
            onEdit={() => router.push(routesByValue.editMenu.getRoute(rowData.id))}
            onDelete={() => onOpenTempState({
              action: () => deleteMenu(rowData.id),
              content: `Delete ${rowData.name}.`,
            })}
            menus={{
              duplicate: {
                name: 'Duplicate',
                icon: <ContentCopy />,
                onClick: () => {
                  setOpenModal(true)
                  setOriginalResourceInfo(rowData)
                  setNewResourceName(`${rowData.name} (copy)`)
                },
              },
            }}
          />
        ),
        cellProps: {
          className: 'more-actions',
        },
      },
    ]
    return (
      <AwesomeTable
        defaultSortKey={'name'}
        defaultSortType={'asc'}
        rawData={menus}
        config={config}
        loading={duplicateStatus.isRequest || deleteMenuStatus.isRequest}
      >
        {renderAddResourceButton()}
      </AwesomeTable>
    )
  },
)

ViewAllMenus.propTypes = {}
ViewAllMenus.defaultProps = {}

export default ViewAllMenus



// WEBPACK FOOTER //
// ./src/pages/Menus/children/ViewAllMenus.js